<div class="cbp-number-request-identifier-type-form">
  <div class="cbp-number-request-identifier-type-form__options">
    <div
      class="card card-step identifier-type"
      [ngClass]="{
        'is-selected': !formGroup?.get('identifierQualifier').value
      }"
    >
      <div class="card-header">
        <app-radio-button
          [id]="'identifier-no-ssn-or-ein'"
          classGroup="m-0 flex-grow-1"
          value=""
          [name]="'identifier'"
          [control]="formGroup?.get('identifierQualifier')"
          [label]="'LABELS.ASSIGNED_CBP_NUMBER_IDENTIFIER_TYPE.NO_SSN_OR_EIN' | translate"
          [isSm]="true"
        ></app-radio-button>
      </div>
    </div>

    <div
      class="card card-step identifier-type"
      [ngClass]="{
        'is-selected': formGroup?.get('identifierQualifier').value === enumIdentifierQualifier.SSN
      }"
    >
      <div class="card-header">
        <app-radio-button
          [id]="'identifier-ssn'"
          classGroup="m-0 flex-grow-1"
          [value]="enumIdentifierQualifier.SSN"
          [name]="'identifier'"
          [control]="formGroup?.get('identifierQualifier')"
          [label]="'LABELS.ASSIGNED_CBP_NUMBER_IDENTIFIER_TYPE.SSN' | translate"
          [isSm]="true"
        ></app-radio-button>
      </div>
    </div>
  </div>
</div>
